import type { IconProps } from "./types";

export function CircleInfo({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
      ? color
      : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 1.7998C5.47126 1.7998 1.7998 5.47126 1.7998 10C1.7998 14.5287 5.47126 18.2002 10 18.2002C14.5287 18.2002 18.2002 14.5287 18.2002 10C18.2002 5.47126 14.5287 1.7998 10 1.7998ZM10 7.59961C10.4971 7.59961 10.9004 8.00294 10.9004 8.5V14.5C10.9004 14.9971 10.4971 15.4004 10 15.4004C9.50294 15.4004 9.09961 14.9971 9.09961 14.5V8.5C9.09961 8.00294 9.50294 7.59961 10 7.59961ZM10.0098 4.09961C10.5068 4.09961 10.9102 4.50294 10.9102 5C10.9102 5.49706 10.5068 5.90039 10.0098 5.90039H10C9.50294 5.90039 9.09961 5.49706 9.09961 5C9.09961 4.50294 9.50294 4.09961 10 4.09961H10.0098Z"
        fill={currentColor}
        transform="translate(2 2)"
      />
    </svg>
  );
}
